import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../../Lib/AxSystem/AxLoad";
import { AxLoading } from "../../../Limestone/AxLoading/AxLoading";
import MobileDetect from "mobile-detect";
import { RequestHelper } from "../../../Lib/Helper/RequestHelper";
import * as components from "./RiderDetailsCompBundle";
import * as models from "./RiderDetailsModelBundle";
import { LoadingSpinnerPositionEnum } from "../../../Lib/Enums/LoadingSpinnerPositionEnum";
import { ProductAndRiderDetailsService } from "../Services/ProductAndRiderDetailsService";

export interface IRentalRiderDetailsInit {
    model: models.ProductAndRiderDetails[];
}


@ModuleName("RiderDetailsModule")
export class RiderDetailsModule implements AxInit {
    private axLoading: AxLoading;
    private mobileDetect: MobileDetect;

    private addToCartBtn: HTMLButtonElement;

    private activeProductPortlet: components.ProductInfoPortlet;
    private productInfoPortlets: components.ProductInfoPortlet[] = [];
    private riderSelection: components.RiderSelection;
    private lockerDataComp: components.LockerData;
    private personDataForm: components.PersonDataForm;
    private rentalPropertiesSelection: components.RentalPropertiesSelection;

    AxInit(init: IRentalRiderDetailsInit): void {
        this.axLoading = new AxLoading();
        this.mobileDetect = new MobileDetect(window.navigator.userAgent);

        this.riderSelection = new components.RiderSelection();
        this.initProductPortletComponents(init.model);

        if (!this.mobileDetect.mobile()) {
            this.selectFirstPortlet();
        }

        this.initAddToCartBtn();
    }

    getAllProductInfoPortlets(): components.ProductInfoPortlet[] {
        return this.productInfoPortlets;
    }

    changeActiveProductPortlet(activatedProductPortlet: components.ProductInfoPortlet) {
        if (this.activeProductPortlet != undefined) {
            this.activeProductPortlet.checkFormValidityAndSetStates();
            this.activeProductPortlet.setPortletInActive();
        }

        if (this.mobileDetect.mobile()) {
            this.riderSelection.showMobilePersonSelection();
        }

        this.activeProductPortlet = activatedProductPortlet;
        this.loadLockerPartial(activatedProductPortlet.getProductAndRiderDetails());
        this.loadRentalPropertiesSelection(activatedProductPortlet);
        this.updateLabelsAndPersonDataArea();
    }

    loadRentalPropertiesSelection(productPortlet: components.ProductInfoPortlet) {
        const holder = document.getElementsByClassName('rental_detail_rider__right_container-rental-properties')[0];
        holder.innerHTML = '';

        const prodAndRiderDetails = productPortlet.getProductAndRiderDetails();
        this.rentalPropertiesSelection = new components.RentalPropertiesSelection(prodAndRiderDetails);
    }

    loadAccountData(accountId: number) {
        const url = "/RentalRiderDetails/GetCustomerAccountRentalData";

        this.setAccountIdToProduct(accountId);

        const proAndRiderDetails = this.activeProductPortlet.getProductAndRiderDetails();

        const data = {
            addToCartFormModel: proAndRiderDetails
        }

        if (!this.mobileDetect.mobile()) {
            this.axLoading.ShowLoadingIndicatorGreyBackGround($('.rental_detail_rider__right_container-data-area')[0], LoadingSpinnerPositionEnum.Top);
        } else {
            this.axLoading.ShowLoadingIndicator($('.rental_detail_rider__right_container-data-area')[0], false, LoadingSpinnerPositionEnum.Top);
        }

        AxessViewer.loadPartialView(url, data, (res) => {
            const success: boolean = res.success;

            if (!success) {

                if (res.ageCheckFailed) {
                    this.setAgeCheckFailedStatus(res.errorMsg);
                    this.axLoading.HideLoadingIndicator($('.rental_detail_rider__right_container-data-area')[0]);
                    return;
                }

                const requestHelper = new RequestHelper();
                requestHelper.postToUrl(`/${cultureInfo}/Rental/LandingPage`, {}, {});
            }

            $('.rental_detail_rider__right_container-person-data').html(res.returnView);

            if (this.lockerIncluded()) {
                this.lockerDataComp.setLockerData(proAndRiderDetails);
            }

            this.setValuesFromResultToProductAndRiderDetails(res);

            this.personDataForm = new components.PersonDataForm(res.customerRentalData.unitSystem);
            this.personDataForm.initInputsAsync(this.activeProductPortlet.getProductAndRiderDetails())
                .then(x => {
                    this.activeProductPortlet.updatePersonInfoTexts();
                    this.riderSelection.setSelectedPersonDataTexts(res.customerRentalData.dateOfBirth, res.customerRentalData.customerEmail);

                    this.activeProductPortlet.checkFormValidityAndSetStates();

                    this.axLoading.HideLoadingIndicator($('.rental_detail_rider__right_container-data-area')[0]);
                    this.riderSelection.hideAlertBanner();
                });
        }, {});
    }

    getLockerDataComponent(): components.LockerData {
        return this.lockerDataComp;
    }

    getPersonRentalDataForm(): components.PersonDataForm {
        return this.personDataForm;
    }

    getActiveProductPortlet(): components.ProductInfoPortlet {
        return this.activeProductPortlet;
    }

    lockerIncluded(): boolean {
        return $('.rental_customer_details-lockerWtp').length > 0;
    }

    private initProductPortletComponents(productAndRiderDetailsList: models.ProductAndRiderDetails[]) {
        const allPortlets = document.querySelectorAll(".rental_details_rider__product_portlet");

        for (let i = 0; i < allPortlets.length; i++) {
            const productPosition = allPortlets[i].getAttribute('rider-details-productPosition');
            const productAndRiderDetails = productAndRiderDetailsList.find(x => x.productPositionId === productPosition);
            const newPortlet = new components.ProductInfoPortlet(allPortlets[i] as HTMLDivElement, productAndRiderDetails);
            this.productInfoPortlets.push(newPortlet);
        }
    }

    private selectFirstPortlet() {
        this.productInfoPortlets[0].activatePortlet();
    }

    private initAddToCartBtn() {
        this.addToCartBtn = document.getElementsByClassName('rental_detail_rider__btn-add_to_cart')[0] as HTMLButtonElement;

        this.addToCartBtn.addEventListener("click",
            x => {
                this.getActiveProductPortlet().checkFormValidityAndSetStates().then(valid => {
                    if (!valid) {
                        return;
                    }

                    const everyThingSet = this.checkIfAllProductsHavePerson();
                    if (everyThingSet) {
                        this.addToCart();
                        return;
                    }

                    let portlet = this.getActiveProductPortlet();

                    if (portlet) {
                        const index = this.productInfoPortlets.indexOf(portlet);
                        if (index < this.productInfoPortlets.length - 1) {
                            this.productInfoPortlets[index + 1].activatePortlet();
                            return;
                        }
                    }
                });
            });
    }

    private checkIfAllProductsHavePerson(): boolean {
        let everyThingSet = true;

        for (let i = 0; i < this.productInfoPortlets.length; i++) {
            if (this.productInfoPortlets[i].getProductAndRiderDetails()?.riderData?.customerAccountId === undefined) {
                everyThingSet = false;
            }
        }

        return everyThingSet;
    }

    private addToCart() {
        const url = "/RentalRiderDetails/AddRentalsToCart";

        this.axLoading.ShowLoadingIndicatorFixed($('.ax-content')[0]);

        let productAndRiderDetails = ProductAndRiderDetailsService.getInstance()
            .getProductAndRiderDetails(this.productInfoPortlets);

        AxessViewer.loadPartialView(url,
            {
                rentalDetailsProdInfos: productAndRiderDetails
            },
            (res) => {
                AxLoad.LoadModule('AxFireShoppingCartModal',
                    {
                        result: res,
                        continueShoppingPath: 'rental',
                        btn: '.rental_detail_rider__btn-add_to_cart',
                        ResetQuantity: null
                    });
                this.axLoading.HideLoadingIndicator($('.ax-content')[0]);
            },
            {
                silent: true,
                skipShoppingCartReload: false
            });
    }

    private updateLabelsAndPersonDataArea() {
        const productAndRiderDetails = this.activeProductPortlet.getProductAndRiderDetails();

        if (this.activeProductPortlet != undefined && productAndRiderDetails.customerAccountNr !== 0) {
            this.riderSelection.setDataAfterSelect(productAndRiderDetails);
            this.loadAccountData(productAndRiderDetails.customerAccountNr);
        } else {
            $('.rental_detail_rider__right_container-person-data').html("");
            this.riderSelection.resetPortlet();
        }
    }

    private loadLockerPartial(productAndRiderDetails: models.ProductAndRiderDetails) {
        // rentalItemType 1 = locker

        if (productAndRiderDetails.rentalItemType !== 1 &&
            productAndRiderDetails.includedPackageItems.every(x => x.rentalItemType !== 1)) {
            $('.rental_detail_rider__right_container-locker-data').html('');
            return;
        }

        const url = "/RentalRiderDetails/GetRiderDetailsLockerPartial";

        const data = {

        }

        AxessViewer.loadPartialView(url, data, (res) => {
            const success: boolean = res.success;

            if (!success) {
                return;
            }

            $('.rental_detail_rider__right_container-locker-data').html(res.returnView);

            this.lockerDataComp = new components.LockerData();
        }, {});
    }

    private setAgeCheckFailedStatus(errorMsg: string) {
        this.riderSelection.showAlertBanner(errorMsg, 'danger');

        this.riderSelection.resetDrownDown();

        const personDataForm = this.getPersonRentalDataForm();

        if (personDataForm != undefined) {
            personDataForm.setEmptyValues(this.activeProductPortlet.getProductAndRiderDetails());
            this.riderSelection.resetSelectedPersonDataTexts();
            this.activeProductPortlet.updatePersonInfoTexts();
        }

        this.activeProductPortlet.setUserNotSelectedState();

        $('.rental_detail_rider__right_container-person-data').html("");
    }

    private setAccountIdToProduct(accountId: number) {
        const prodDetails = this.activeProductPortlet.getProductAndRiderDetails();

        if (prodDetails.riderData == null || prodDetails.riderData == undefined) {
            prodDetails.riderData = new models.RiderData();
        }

        prodDetails.riderData.customerAccountId = accountId;
        prodDetails.customerAccountNr = accountId;
    }

    private setValuesFromResultToProductAndRiderDetails(res: any) {
        let productAndRiderDetails = this.activeProductPortlet.getProductAndRiderDetails();

        if (productAndRiderDetails.riderData == null || productAndRiderDetails.riderData == undefined) {
            productAndRiderDetails.riderData = new models.RiderData();
        }

        productAndRiderDetails.riderData.customerAccountId = res.customerRentalData.customerAccountId;

        productAndRiderDetails.riderData.shoeSizeSystem = res.customerRentalData.shoeSizeSystem;
        productAndRiderDetails.riderData.unitSystem = res.customerRentalData.unitSystem;

        productAndRiderDetails.riderData.customerName = res.customerRentalData.customerName;
        productAndRiderDetails.riderData.customerEmail = res.customerRentalData.customerEmail;
        productAndRiderDetails.riderData.dateOfBirth = res.customerRentalData.dateOfBirth;

        productAndRiderDetails.riderData.weight = res.customerRentalData.weight;
        productAndRiderDetails.riderData.height = res.customerRentalData.height;
        productAndRiderDetails.riderData.soleLength = res.customerRentalData.soleLength;
        productAndRiderDetails.riderData.shoeSize = res.customerRentalData.shoeSize;
        productAndRiderDetails.riderData.gender = res.customerRentalData.gender;
        productAndRiderDetails.riderData.skillLevel = res.customerRentalData.skillLevel;

        productAndRiderDetails.riderData.phone = res.customerRentalData.phone;

        productAndRiderDetails.riderData.city = res.customerRentalData.city;
        productAndRiderDetails.riderData.zipCode = res.customerRentalData.zipCode;
        productAndRiderDetails.riderData.country = res.customerRentalData.country;
        productAndRiderDetails.riderData.street = res.customerRentalData.street;
        //productAndRiderDetails.riderData.houseNumber = res.customerRentalData.houseNumber; // not yet needed
        productAndRiderDetails.riderData.state = res.customerRentalData.state;
        productAndRiderDetails.riderData.passportId = res.customerRentalData.passportId;
    }
}

